// Copyright 2025, University of Maryland, All Rights Reserved
/**
 * Federal Connector Sync processing node registration.
 */
import { registerPipelineNode } from '../../../core/pipeline-registry'
import { FederalConnectorSyncAdminView } from './components/AdminView'
import { FederalConnectorSyncWorkflowNode } from './components/WorkflowNode'

registerPipelineNode({
  id: 'processing.federal-connector-sync',
  manifest: {
    id: 'processing.federal-connector-sync',
    name: 'Federal Connector Sync',
    category: 'processing',
    icon: 'RefreshCw',
    description: 'Trigger score pipelines for updated federal bills',
    order: 25,
  },
  WorkflowNode: FederalConnectorSyncWorkflowNode,
  AdminConfig: FederalConnectorSyncAdminView,
})
